import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { getImportUrl } from "../../services/axios";

/*

SIMPLE UPLOAD FONT FILE TO S3

*/

export const AddFont = () => {
  let [file, setFile] = useState<any>(null);

  let [fontState, setFontState] = useState<any>({
    url: "",
    progress: "0",
  });

  let [state] = useState<any>({});

  const handleFontUploadChange = (e: any) => {
    return setFile(e.target.files[0]);
  };

  const handleFontUpload = async (e: any) => {
    e.preventDefault();
    // content type should be image for the copy to work properly on server
    // this is not a reflection of actual content type. font type will break.
    var getS3UploadURL = await getImportUrl(file.name, "image/*", "fonts");
    const config = {
      headers: {
        "Content-Type": "image/*",
      },
      onUploadProgress: function (progressEvent: any) {
        var percentCompleted = Math.round(
          (progressEvent.loaded * 100) / progressEvent.total
        );
        setFontState({
          ...state,
          progress: `${percentCompleted}%`,
        });
      },
    };
    return axios
      .put(getS3UploadURL, file, config)
      .then((res) => {
        console.log("url", res.config.url);
        setFontState({
          ...state,
          progress: "Success",
          url: res.config.url,
        });
        toast.success("uploaded", { duration: 5000 });
      })
      .catch((e: any) => {
        toast.error(e.message, { duration: 5000 });
        setFontState({
          ...state,
          progress: e,
        });
      });
  };

  return (
    <div className="h-full w-full">
      <form className="w-full" onSubmit={handleFontUpload}>
        <p className="font-lato font-semibold text-md mb-3">
          Upload Font File (TTF/ttf/OTF/otf)
        </p>
        <div className="flex items-center">
          <input type="file" onChange={handleFontUploadChange} />
          <p>{fontState.progress}</p>
          <button
            className="font-black text-md rounded-full p-2 m-2"
            disabled={!file}
          >
            upload
          </button>
        </div>
      </form>
    </div>
  );
};
